import { getUser, getToken, setUser, setToken, logout } from '@/services/auth.service'

const user = {
  namespaced: true,
  state: {
    user: getUser(),
    token: getToken(),
    resetRequested: false,
    isOTPValid: false
  },
  mutations: {
    REQ_BEGIN(state) { },
    REQ_END(state) { },
    REQ_ERROR(state, error) { },
    SET_USER(state, user) {
      setUser({ ...user })
      state.user = getUser()
    },
    SET_TOKEN(state, token) {
      setToken(token)
      state.token = getToken()
    },
    SET_LOGOUT(state) {
      logout()
      state.user = null
      state.token = null
    },
    SET_RESET_REQUESTED(state, requested) {
      state.resetRequested = requested
    },
    SET_IS_OTP_VALID(state, isValid) {
      state.isOTPValid = isValid
    }
  },
  actions: {
    async login({ commit }, { email, password }) {
      try {
        const { user, token } = await this.$api.loginWithEmailAndPassword(email, password)
        commit('SET_USER', user)
        commit('SET_TOKEN', token)
        return Promise.resolve()
      } catch (err) {
        commit('REQ_ERROR', err)
        return Promise.reject(err)
      }
    },
    async requestPasswordReset({ commit }, { email }) {
      try {
        await this.$api.requestPasswordResetWithEmail(email)
        commit('SET_RESET_REQUESTED', true)
        return Promise.resolve()
      } catch (err) {
        commit('REQ_ERROR', err)
        return Promise.reject(err)
      }
    },
    async generateOTP({ commit }, { token }) {
      try {
        await this.$api.generateOTP(token)
        return Promise.resolve()
      } catch (err) {
        commit('REQ_ERROR', err)
        return Promise.reject(err)
      }
    },
    async validateOTP({ commit }, { otp }) {
      try {
        const { isValid } = await this.$api.validateOTP(otp)
        commit('SET_IS_OTP_VALID', isValid)
        return Promise.resolve()
      } catch (err) {
        commit('REQ_ERROR', err)
        return Promise.reject(err)
      }
    },
    async passwordResetRequest({ commit }, { token, password }) {
      try {
        await this.$api.processPasswordReset(token, password)
        return Promise.resolve()
      } catch (err) {
        commit('REQ_ERROR', err)
        return Promise.reject(err)
      }
    },
    logout({ commit }) {
      commit('SET_LOGOUT')
    }
  },
  getters: {
    user: state => state.user,
    role: state => state.user.role || null,
    token: state => state.token,
    validOTP: state => state.isOTPValid
  }
}

export default user
